import React from "react";

const SupportPage = () => {
  return (
    <div>
      <h3 className="fw-bold">Support</h3>
      <p className="text-muted">Need help? Contact Afrogebeya support.</p>

      <div className="card p-2 shadow-sm">
        <textarea
          className="form-control"
          rows="4"
          placeholder="Describe your issue..."
        ></textarea>

        <button className="btn btn-primary mt-3">Submit your issue</button>
      </div>
    </div>
  );
};

export default SupportPage;
